module.exports = __webpack_public_path__ + "f367dd65def3db794ce67c2d79aa980e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/service/one/one-bg.jpg
// module id = 1212
// module chunks = 0